import React from 'react';
import {
  MeasurementFetchByDateConnectorApollo,
  MeasurementSaveByDateConnectorApollo,
  MeasurementDeleteByDateConnectorApollo,
} from '@front-activerse/common-components';
import EditMeasurementContainer from './EditMeasurementContainer';
import { useParams } from 'react-router-dom';
import { useTimestamp, useAppContext } from '@front-activerse/common-components';

interface IEditMeasurementPageProps {
  availableMeasurements: string[][];
}

const EditMeasurementPage: React.FC<IEditMeasurementPageProps> = ({ availableMeasurements }) => {
  const params = useParams();
  const { timestamp2 } = useTimestamp();
  const { post } = useAppContext();

  return (
    <MeasurementFetchByDateConnectorApollo date={params.date}>
      {(fetchData: any) => (
        <MeasurementSaveByDateConnectorApollo post={post}>
          {(saveData: any) => (
            <MeasurementDeleteByDateConnectorApollo>
              {(deleteData: any) => (
                <EditMeasurementContainer
                  key={timestamp2}
                  {...fetchData}
                  {...saveData}
                  {...deleteData}
                  availableMeasurements={availableMeasurements}
                />
              )}
            </MeasurementDeleteByDateConnectorApollo>
          )}
        </MeasurementSaveByDateConnectorApollo>
      )}
    </MeasurementFetchByDateConnectorApollo>
  );
};

export default EditMeasurementPage;
